<ng-container>
  <ln-icon *ngIf="direction === ArrowDirection.Left" name="arrow-right" class="turn-arrow icon-left"></ln-icon>
  <ng-content></ng-content>
  <ln-icon class="icon-right" *ngIf="direction === ArrowDirection.Right" name="arrow-right"></ln-icon>
</ng-container>
